import { Button, Heading } from '@innovationnorway/cl-react';
import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import BrregCompanySearch from 'src/components/BrregCompanySearch/BrregCompanySearch';

type Props = {
  onClick: (organizationNumber: string, name: string) => void;
  onSkip: undefined | (() => void);
  selectedCompany?: { organizationNumber: string; name: string };
  onClearSelection: () => void;
};

const NewCompanyBrregSearch: React.FC<Props> = ({ onClick, onSkip, selectedCompany, onClearSelection }) => {
  const { t: tSiva } = useTranslation('siva');
  const { t: tCommon } = useTranslation();
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return (
    <>
      <Heading level={2}>{tSiva('newCompany.brregSearch.title')}</Heading>

      <p>{tSiva('newCompany.brregSearch.description')}</p>

      <BrregCompanySearch
        label={tSiva('newCompany.brregSearch.search.label')}
        className="margin-bottom--4"
        inputRef={inputRef}
        onClearSelection={onClearSelection}
        onSelect={({ organizationNumber, name }) => onClick(organizationNumber, name)}
      />

      {selectedCompany && (
        <div className="margin-bottom--4">
          <p>{`${selectedCompany.organizationNumber} - ${selectedCompany.name}`}</p>
          <Button
            type="button"
            variant="primary"
            onClick={() => onClick(selectedCompany.organizationNumber, selectedCompany.name)}
          >
            {tCommon('next')}
          </Button>
        </div>
      )}

      {onSkip && <Button onClick={onSkip}>Gå videre uten bedrift</Button>}
    </>
  );
};

export default NewCompanyBrregSearch;
